import { combineReducers } from 'redux';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Call, CallFolder } from '../../model';
import { Actions, StoreState } from '../types';
import produce from 'immer';
import { ItemSelected } from '../../Components/SearchPage';

type Folders = Record<CallFolder, Call[] | undefined>

const EmptyFolders: Folders = {
  'received': undefined,
  'placed': undefined,
  'missed': undefined,
}

function folders(state: Folders = EmptyFolders, action: Actions): Folders {
  switch (action.type) {
    case getType(actions.fetchCalls.response):
      {
        return {
          ...state,
          [action.payload.folder]: action.payload.items,
        }
      }

    case getType(actions.updateCallHistory): {
      const { folder, history } = action.payload
      const data = state[folder]

      if (!data) return state

      return produce(state, state => {
        const d = data.filter(x => x.id !== history.id)
        d.push(history)
        d.sort((a, b) => a.date < b.date ? 1 : -1)
        state[folder] = d
      })
    }

    case getType(actions.deleteCallHistory): {
      const { folder, id } = action.payload
      const data = state[folder]

      if (!data) return state

      return produce(state, state => {
        state[folder] = data.filter(x => x.id !== id)
      })
    }

    case getType(actions.clearCalls):
      return {
        ...state,
        [action.payload]: [],
      }

    case getType(actions.forceReload):
      {
        return EmptyFolders
      }

    default:
      return state
  }
}

function missed(state: number = 0, action: Actions): number {
  if (action.type === getType(actions.fetchCalls.response) && action.payload.folder === 'missed') {
    return action.payload.items.filter(call => !call.read).length
  }

  if (action.type === getType(actions.updateMissedCallsCount)) {
    return action.payload
  }

  return state
}

export default combineReducers({
  folders,
  missed,
})

function getRoot(state: StoreState) { return state.calls }

export function selectCalls(state: StoreState, folder: CallFolder) {
  return getRoot(state).folders[folder]
}

export function selectMissedCallsCount(state: StoreState) {
  return getRoot(state).missed
}

export function selectRecentItem(state: StoreState, item: ItemSelected) {
  const data = getRoot(state)
  if (data && data.folders) {
    if (data.folders.missed) {
      for (const call of data.folders.missed) {
        if (call.callKey === item.id || call.mediaItemId === item.id)
          return call
      }
    }
    if (data.folders.received) {
      for (const call of data.folders.received) {
        if (call.callKey === item.id || call.mediaItemId === item.id)
          return call
      }
    }
    if (data.folders.placed) {
      for (const call of data.folders.placed) {
        if (call.callKey === item.id || call.mediaItemId === item.id)
          return call
      }
    }
  }

  return null
}

